(function () {
  let filterContainers = document.querySelectorAll('[data-filter-container]');
  const navbar = document.querySelector('#main-nav');
  let menu = '',
    btn = '';
  if (navbar) {
    menu = navbar.querySelector('#mobile-nav');
    btn = navbar.querySelector('#main-nav-toggle');
  }

  const servicesCategory = document.querySelector('#servicesCategory');
  const navListWrapper = document.querySelector('#nav-list-wrapper');

  filterContainers.forEach((filterContainer) => {
    let filterTabs = filterContainer.querySelector('[data-filter-tabs]');
    let filterContent = filterContainer.querySelector('[data-filter-content]');
    let currentFilter = null;

    filterTabs.querySelectorAll('a').forEach((l) => {
      l.onclick = (ev) => {
        ev.preventDefault();
        currentFilter =
          l.getAttribute('href') == '#'
            ? null
            : l.getAttribute('href').replace('#', '');

        filterTabs.querySelectorAll('a').forEach((a) => {
          a.firstChild.classList.remove('active');
          currentTab =
            a.getAttribute('href') == '#'
              ? null
              : a.getAttribute('href').replace('#', '');
          if (currentFilter == currentTab) {
            a.firstChild.classList.add('active');
          }
        });

        filterContent.querySelectorAll('[data-filter-value]').forEach((elm) => {
          elm.classList.remove('hidden');
          if (
            currentFilter !== null &&
            elm.dataset.filterValue !== currentFilter
          ) {
            elm.classList.add('hidden');
          }
        });
      };
    });
    if (filterTabs.querySelectorAll('a')[0]) {
      filterTabs.querySelectorAll('a')[0].click();
    }
  });
  //This catergory section used for small screen Dropdown

  const selectCategory = document.querySelector('#ConTabRegions');
  if (selectCategory) {
    selectCategory.addEventListener('change', (e) => {
      const categoryFilterContainer = document.querySelector(
        '[data-filter-container]'
      );
      const categoryFilterContent = categoryFilterContainer.querySelector(
        '[data-filter-content]'
      );
      let categoryCurrentFilter =
        document.getElementById('ConTabRegions').value;
      categoryFilterContent
        .querySelectorAll('[data-filter-value]')
        .forEach((elm) => {
          elm.classList.remove('hidden');
          if (
            categoryCurrentFilter !== null &&
            categoryCurrentFilter !== '' &&
            elm.dataset.filterValue !== categoryCurrentFilter
          ) {
            elm.classList.add('hidden');
          }
        });
    });
  }
  var filterTabs = document.querySelector('[data-filter-tabs]');
  if (window.location.href.includes('Insights#Podcasts')) {
    setTimeout(() => {
      let filterTabs = document.querySelector('[data-filter-tabs]');
      if (filterTabs) {
        filterTabs.querySelectorAll('a')[1].click();
        selectCategory.value = 'podcasts';
      }
    }, 2000);
  }
  if (window.location.href.includes('Insights#Videos')) {
    setTimeout(() => {
      if (filterTabs) {
        filterTabs.querySelectorAll('a')[2].click();
        selectCategory.value = 'videos';
      }
    }, 2000);
  }
  if (window.location.href.includes('Insights#WhitePapers')) {
    setTimeout(() => {
      if (filterTabs) {
        filterTabs.querySelectorAll('a')[3].click();
        selectCategory.value = 'white-papers';
      }
    }, 2000);
  }

  let megaMenuInsightsArticles = document.getElementById(
    'megaMenuInsightsArticles'
  );
  if (megaMenuInsightsArticles) {
    megaMenuInsightsArticles.onclick = (e) => {
      if (filterTabs) {
        filterTabs.querySelectorAll('a')[0].click();
      }
    };
  }

  let megaMenuInsightsPodcasts = document.getElementById(
    'megaMenuInsightsPodcasts'
  );
  if (megaMenuInsightsPodcasts) {
    megaMenuInsightsPodcasts.onclick = (e) => {
      if (filterTabs) {
        filterTabs.querySelectorAll('a')[1].click();
      }
    };
  }

  let megaMenuInsightsVideos = document.getElementById(
    'megaMenuInsightsVideos'
  );
  if (megaMenuInsightsVideos) {
    megaMenuInsightsVideos.onclick = (e) => {
      if (filterTabs) {
        filterTabs.querySelectorAll('a')[2].click();
      }
    };
  }

  let megaMenuInsightsWhitePapers = document.getElementById(
    'megaMenuInsightsWhitePapers'
  );
  if (megaMenuInsightsWhitePapers) {
    megaMenuInsightsWhitePapers.onclick = (e) => {
      if (filterTabs) {
        filterTabs.querySelectorAll('a')[3].click();
      }
    };
  }

  // mobile navigation for insights

  let megaMenuInsightsMobArticles = document.getElementById('mob-nav-articles');
  if (megaMenuInsightsMobArticles) {
    megaMenuInsightsMobArticles.onclick = (e) => {
      if (selectCategory) {
        selectCategory.value = 'leadership';
        selectCategory.dispatchEvent(new Event('change'));
        menu.classList.add('hidden');
        btn.classList.toggle('open');
      }
    };
  }
  let megaMenuInsightsMobPodcasts = document.getElementById('mob-nav-podcasts');
  if (megaMenuInsightsMobPodcasts) {
    megaMenuInsightsMobPodcasts.onclick = (e) => {
      if (selectCategory) {
        selectCategory.value = 'podcasts';
        selectCategory.dispatchEvent(new Event('change'));
        menu.classList.add('hidden');
        btn.classList.toggle('open');
      }
    };
  }

  let megaMenuInsightsMobVideos = document.getElementById('mob-nav-videos');
  if (megaMenuInsightsMobVideos) {
    megaMenuInsightsMobVideos.onclick = (e) => {
      if (selectCategory) {
        selectCategory.value = 'videos';
        selectCategory.dispatchEvent(new Event('change'));
        menu.classList.add('hidden');
        btn.classList.toggle('open');
      }
    };
  }

  let megaMenuInsightsMobWhitePapers = document.getElementById(
    'mob-nav-white-papers'
  );
  if (megaMenuInsightsMobWhitePapers) {
    megaMenuInsightsMobWhitePapers.onclick = (e) => {
      if (selectCategory) {
        selectCategory.value = 'white-papers';
        selectCategory.dispatchEvent(new Event('change'));
        menu.classList.add('hidden');
        btn.classList.toggle('open');
      }
    };
  }

  if (servicesCategory) {
    servicesCategory.addEventListener('change', (e) => {
      document.location.href = e.target.value;
    });
  }

  let activeNavList = document.getElementById('active-nav-list');
  if (activeNavList) {
    activeNavList.onclick = (e) => {
      setTimeout(() => {
        if (navListWrapper && navbar) {
          navbar.classList.remove('awards-nav-top');
          navListWrapper.classList.remove('awards-nav-list');
          navbar.classList.add('-translate-y-full');
        }
      }, 1000);

      if (document.querySelector('#active-nav-list a span.active') !== null) {
        document
          .querySelector('#active-nav-list a span.active')
          .classList.remove('active');
      }
      e.target.className = 'link-highlight p-2 active';
    };
  }

  /* to show sections according to language selection */

  let countryJson = [
    {
      name: 'India',
      code: 'en-in',
    },
    {
      name: 'North America',
      code: 'en-us',
    },
    {
      name: 'United Kingdom',
      code: 'en-gb',
    },
    {
      name: 'Europa',
      code: 'nl-nl',
    },
    {
      name: 'Europe',
      code: 'en-rs',
    },
    {
      name: 'Asia-Pacific',
      code: 'en-au',
    },
    {
      name: 'North America',
      code: 'en-ca',
    },
    {
      name: 'Asia-Pacific',
      code: 'en-sg',
    },
    {
      name: 'Middle East',
      code: 'en-ae',
    },
    {
      name: 'Asia-Pacific',
      code: 'en-hk',
    },
    {
      name: 'Asia-Pacific',
      code: 'en-jp',
    },
  ];

  let language = window.location.pathname.split('/')[1];
  if (language) {
    let filterContactUs = document.querySelector('[data-filter-tabs]');
    if (filterContactUs) {
      let anchorContactTags = filterContactUs.querySelectorAll('a');
      let anchorContactEle = Array.from(anchorContactTags);
      anchorContactEle.forEach((ele) => {
        countryJson.forEach((country) => {
          if (ele.innerText == country.name && language == country.code) {
            ele.click();
          }
        });
      });
    }
  }
})();
